import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import "./AlumniLogin.css";

const AlumniLogin = ({ setUser }) => { // ✅ Accept setUser prop
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (message.text) setMessage({ type: "", text: "" });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setMessage({ type: "error", text: "Please enter both email and password." });
      return;
    }

    setIsLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const res = await api.post("/api/auth/login", {
        email: formData.email,
        password: formData.password
      });

      // 1. Save to LocalStorage
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("loggedInUser", JSON.stringify(res.data.user));

      // 2. ✅ Update React State immediately (Fixes the redirect issue)
      if (setUser) {
        setUser(res.data.user);
      }

      // 3. Redirect immediately
      navigate("/dashboard", { replace: true });
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Invalid email or password."
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-hero">
          <div className="login-badge">CIT - Alumni BLR Network Portal</div>
          <h1>Welcome Back, CIT - Alumni Bangalore</h1>
          <p>Log in to access your profile, connect with peers, and stay updated.</p>
        </div>

        <div className="login-card">
          <div className="login-header">
            <h2>Login to Your Account</h2>
          </div>

          {message.text && (
            <div className={`message-banner ${message.type}`}>
              {message.text}
            </div>
          )}

          <form onSubmit={handleLoginSubmit} className="login-form">
            <div className="input-wrapper">
              <label htmlFor="email">Email ID</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your registered email"
                required
              />
            </div>

            <div className="input-wrapper">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
            </div>

            <div className="forgot-password-link">
              <span
                onClick={() => navigate("/forgot-password")}
                style={{ cursor: "pointer", color: "#007bff" }}
              >
                Forgot your password?
              </span>
            </div>

            <button type="submit" className="submit-btn" disabled={isLoading}>
              {isLoading ? "Logging in..." : "Login"}
            </button>

            <div className="auth-footer">
              Don't have an account?{" "}
              <span onClick={() => navigate("/register")}>Register here</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AlumniLogin;